import { LinkType } from '@ria-client/segment/enums';
import type { AnalyticsType } from '@ria-client/segment/types';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import type { CtaType, ImageType } from '@ria-client/supergraph/roundup/types';
import { TrackedLink } from '@ria-client/tw-shared-ui';

export interface CtaImageProps {
  ctaAnalytics: AnalyticsType;
  image?: ImageType;
  cta?: CtaType;
  displayName?: string;
}

export function CtaImage({ ctaAnalytics, cta, displayName, image }: CtaImageProps) {
  if (!image?.source) return null;

  const logo = (
    <img
      alt={image.alt ?? displayName ?? 'Product logo'}
      className="h-[90px] w-[155px] object-contain sm:h-[88px] sm:w-[244px]"
      height={88}
      src={image.source}
      width={244}
    />
  );

  if (!cta) return logo;

  return (
    <TrackedLink
      analyticsPayload={ctaAnalytics}
      cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductImage }}
      linkType={LinkType.PRODUCT_IMAGE}
      monetizable={ctaAnalytics.monetizable}
    >
      {logo}
    </TrackedLink>
  );
}
